import { ca } from '@cian/analytics';

import { type IPromo } from '../../../../types/promos';
import { getProductsData } from '../../../../utils/getProductsData';

/**
 * @description Событие: клик по офферу Циан-ипотеки в деталях промо (карточка ипотечного продукта).
 */
export function trackCianMortgageClick(promo: IPromo): void {
  const { promoType, uniquePromoId: promoCianMortgage } = promo;

  ca('eventSite', {
    action: 'click_mortgage',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData({ promoCianMortgage })],
  });
}
